<template>
  <div>
    <font-awesome-icon
      :icon="icon"
      class="icon"
      fixed-width
    />
    <span class="visibility-label">{{ visibility }}</span>
  </div>
</template>

<script>
import { pageMixin } from '../node-element-permission-level-common'

export default {
  mixins: [
    pageMixin
  ],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
    }
  }

}
</script>

<style>
  .visibility-label {
    text-transform: capitalize;
  }
</style>
